import React, { Fragment } from 'react';

export const OrganizationSelectListHidden = ({ organizationList, onOrgSubmit, translate, selectedOrg, selectOnChange }) => (
    <div className="select-org__interaction">
        <input type="hidden" id="selectOrganizationList" value={selectedOrg.id}/>
    </div>
)

export default OrganizationSelectListHidden;
